import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { authenticate } from "../../Redux/Actions/auth";

const waitStyle = {
  color: "green",
  marginBottom: "24px",
  textAlign: "center",
};

const AuthForm = (props) => {

  const { event_title } = props;
  const dispatch = useDispatch();

  //To get form values
  const [email, setState] = useState(props?.data?.email);
  const [mobile_number, setMobile] = useState(props?.data?.number);
  const [guardians_name, setGaurdians] = useState(props?.data?.name);

  const [success, setSuccess] = useState("");
  const [successMsg, setMsgSuccess] = useState("");
  const [waitMsg, setWaitMsg] = useState("");

  //set email
  const registerEmailHandler = (event) => {
    setState(event.target.value);
  };

  //set mobile number
  const registerGardianNameHndler = (event) => {
    setGaurdians(event.target.value);
  };

  //set mobile number
  const registerMobileHandler = (event) => {
    setMobile(event.target.value);
  };

  const narcSubmitOne = (e) => {
    e.preventDefault();

    // const check = email.includes(".");
    // const valid = email.includes("@");
    // const checkEmailCount = (email.match(new RegExp("@", "g")) || []).length;

    //mobile validation
    if (mobile_number === "" || mobile_number === undefined) {
      setMsgSuccess("Please enter mobile number");
    }
    // if (guardians_name === "" || guardians_name === undefined) {
    //   setMsgSuccess("Please enter guardian’s name");
    // }
    if (mobile_number === "" || mobile_number === undefined) {
      setMsgSuccess("Please enter mobile number");
    } else if (
      mobile_number === "" &&
      validateMobile(mobile_number) === false
    ) {
      setMsgSuccess("Please enter valid mobile number");
    } else if (
      mobile_number !== "" &&
      validateMobile(mobile_number) === false
    ) {
      setMsgSuccess("Please enter valid mobile number");
    } else {
      setMsgSuccess("");
    }

    // if (email === "" && email !== undefined) {
    //   setSuccess("Please enter email");
    // } else if (
    //   email !== "" &&
    //   isEmail(email) === false &&
    //   (check === false || valid === false)
    // ) {
    //   setSuccess("Please enter valid email id");
    // } else if (email !== "" && checkEmailCount !== 1) {
    //   setSuccess("Please enter valid email id");
    // } else if (email !== "" && isEmail(email) === false) {
    //   setSuccess("Please enter valid email id");
    // } else {
    //   setSuccess("");
    // }

    //Generate OTP
    if (
      validateMobile(mobile_number) === true &&
      // isEmail(email) === true &&
      // checkEmailCount === 1 &&
      // email !== "" &&
      // email !== undefined &&
      // check === true &&
      // valid === true &&
      mobile_number !== "" &&
      mobile_number !== undefined
    ) {
      dispatch(authenticate({ mobile: mobile_number }, () => {
        props.onComplete({
          formData: {
            // email: email,
            number: mobile_number,
            // name: guardians_name,
          }
        })
      }))
    }
  };

  function isEmail(val) {
    let regEmail =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    var isValid = regEmail.test(val);
    return isValid;
  }

  function validateMobile(mobile) {
    var isValid = false;
    if (mobile === 0) {
      return isValid;
    }
    if (mobile.length < 6) {
      return isValid;
    }
    var regex = /^[0-9\.\-\+\(\) ]*$/;
    isValid = regex.test(mobile);
    return isValid;
  }

  return (
    <div className="formSection">
      <div className="head">
        <div className="title">Enter credentials for {event_title}</div>
      </div>

      <form className="form stepOne">
        {/* <div className="formGroup">
          <label>
            Name<span className="imp">*</span>
          </label>
          <div className="input">
            {successMsg && <div className="msg error">{successMsg}</div>}
            <input
              type="text"
              id="guardians_name"
              name="guardians_name"
              value={guardians_name}
              onChange={registerGardianNameHndler}
              placeholder="Enter your name"
            />
          </div>
        </div> */}
        <div className="formGroup">
          <label>Mobile Number<span className="imp">*</span></label>
          {successMsg && <div className="msg error">{successMsg}</div>}
          <input
            className="form-control"
            type="tel"
            id="mobile_number"
            name="mobile_number"
            value={mobile_number}
            onChange={registerMobileHandler}
            placeholder="Enter your mobile number"
          />
        </div>
        {/* <div className="formGroup">
          <label>
            Email address<span className="imp">*</span>
          </label>
          <div className="input">
            {success && <div className="msg error">{success}</div>}
            <input
              type="text"
              name="email"
              id="email"
              value={email}
              onChange={registerEmailHandler}
              placeholder="Enter your email"
            />
          </div>
        </div> */}
        <div className="submitMe">
          {waitMsg && (
            <div className="msg error" style={waitStyle}>
              {waitMsg}
            </div>
          )}
          <button
            type="button"
            onClick={narcSubmitOne}
            disabled={!mobile_number}
          >
            Send OTP
          </button>
          <div className="info">
            A six digit OTP will be sent to your contact details
          </div>
        </div>
        <div className="pagenation">
          <ul>
            <li className="current"></li>
            <li></li>
          </ul>
        </div>
      </form>
    </div>
  );
};

export default AuthForm;
